import gql from "graphql-tag";

const RESEND_REALTOR_APPOINTMENT_CONFIRMATION = gql`
  mutation resendRealtorAppointmentConfirmation($appointment_id: ID!) {
    resendRealtorAppointmentConfirmation(appointment_id: $appointment_id) {
      message
      code
    }
  }
`;

export default RESEND_REALTOR_APPOINTMENT_CONFIRMATION;
